import api from '@/services/api'
import { standardForPartnerTipo } from '@/components/Comissoes/commercialStandard'
import type { PartnerCommissionMode, PartnerInstallmentPlan } from '@/types'

export type ConvertLeadTarget = {
  leadId: string
  empresa?: string | null
  contato?: string | null
  parceiroId?: string | null
}

export type ConvertLeadOptions = {
  parceiroId: string | null
  modoComissaoParceiro: PartnerCommissionMode
  comissaoParceiroPlano?: PartnerInstallmentPlan
}

type PartnerOption = {
  id: string
  tipo?: string | null
  modoComissao?: PartnerCommissionMode | null
}

/** Aplica a regra do parceiro já vinculado, sem pedir confirmação na conversão. */
export function buildLeadConvertOptions(
  parceiroId: string | null | undefined,
  tipo?: string | null,
  partnerMode?: PartnerCommissionMode | null,
): ConvertLeadOptions {
  const id = parceiroId || null
  if (!id) return { parceiroId: null, modoComissaoParceiro: 'RECORRENTE' }

  const rule = standardForPartnerTipo(tipo)
  const mode = (rule.ready ? rule.mode : null) ?? partnerMode ?? 'RECORRENTE'
  return {
    parceiroId: id,
    modoComissaoParceiro: mode,
    ...(mode === 'DUAS_MENSALIDADES'
      ? { comissaoParceiroPlano: { parcelas: 1, intervalosMeses: [], beneficiarios: [id] } }
      : {}),
  }
}

export async function requestLeadConvertOptions(target: ConvertLeadTarget): Promise<ConvertLeadOptions> {
  const parceiroId = target.parceiroId || null
  if (!parceiroId) return buildLeadConvertOptions(null)

  try {
    const resp = await api.get('/parceiros/options')
    const rows: PartnerOption[] = resp.data?.data ?? []
    const selected = rows.find((partner) => partner.id === parceiroId)
    return buildLeadConvertOptions(parceiroId, selected?.tipo, selected?.modoComissao)
  } catch {
    return buildLeadConvertOptions(parceiroId)
  }
}
